<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Who Cleans the Park?</h1>
<h1 class="bk1">Public Work and Urban Governance in New York City</h1>
<p class="bkau">John Krinsky and Maud Simonet</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Krinsky-0003.vue?5b6ad3ec